var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix padding-top-large padding-bottom-xlarge padding-left-small margin-left-xlarge header"},[_c('div',{staticClass:"col-xs-11 col-sm-6"},[_c('img',{staticClass:"hlogo",attrs:{"src":require('@/common/assets/styles/corp/images/vzlogoLarge.png')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }